import React from 'react';
import { Link } from '@tanstack/react-router';

interface InternalNavLinkProps {
  children: React.ReactNode;
  routePath: string;
  params: {
    org: string;
    agent: string;
  };
  searchParams?: Record<string, string>;
  onClick?: (e: React.MouseEvent) => void;
}

/**
 * Component for internal navigation (within Gaia)
 * Uses TanStack Router Link with proper params
 */
export const InternalNavLink: React.FC<InternalNavLinkProps> = ({
  children,
  routePath,
  params,
  searchParams,
  onClick,
}) => {
  return (
    <Link to={routePath} params={params} search={searchParams} onClick={onClick}>
      {children}
    </Link>
  );
};
